import type { BankTransferVariantStyles } from "../bankTransfer.variantTypes";
import { colors } from "../../../../../../../ui/colors";

export const defaultStyles: BankTransferVariantStyles = {

    expandable: true,
    transition: "all 0.2s ease",
    root: {
        padding: 16,
        borderRadius: 16,
        borderColor: colors.gray[50],
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        hover: {
            boxShadow: "-6px 6px 10px 0px rgba(0, 0, 0, 0.10)",
            transform: "translateY(-1px)",
            borderColor: colors.gray[100],
        },
    },
    icon: { size: 40, bg: "#ffffff", color: "#0e9925" },
    title: { fontSize: "0.95rem", color: "var(--fx-surface-text, #0F172A)" },
    description: { fontSize: "0.8rem", color: "var(--fx-surface-texttertiary, #94A3B8)", lineHeight: 1.5, marginBottom: 16 },
};